import * as React from "react";

export const Item: React.SFC<any> = (props) => {
    return <div {...props} />;
};
